import { useEffect, useState } from "react";
import { fetchWithAuth } from "../../api/fetchWithAuth";

export default function OperatingAoiAssetSummary({ aoiId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!aoiId) {
      setData(null);
      return;
    }

    fetchWithAuth(
      `/api/v1/platform/operating-aois/${aoiId}/asset-summary`
    )
      .then(r => r.json())
      .then(setData)
      .catch(() => setData(null));
  }, [aoiId]);

  if (!aoiId || !data) return null;

  return (
    <div className="border-t border-bg-border bg-bg-soft p-3 text-xs grid grid-cols-3 gap-3">
      <div>
        <div className="text-lg font-semibold">{data.wells}</div>
        <div className="text-fg-secondary">Wells</div>
      </div>
      <div>
        <div className="text-lg font-semibold">{data.pads}</div>
        <div className="text-fg-secondary">Pads</div>
      </div>
      <div>
        <div className="text-lg font-semibold">{data.tanks}</div>
        <div className="text-fg-secondary">Tanks</div>
      </div>
    </div>
  );
}